import { IsArray, IsInt } from 'class-validator';

export class OrderPositionSortRequest {
    @IsInt()
    public id: number;

    @IsArray()
    @IsInt({ each: true })
    public sort: number[] = [];

    constructor(data?: Partial<OrderPositionSortRequest>) {
        this.id = data?.id;
        this.sort = data?.sort ?? [];
    }
}
